import {ActionCreator, createAction} from '@packages/utilities/create-action';
import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';
import type {
  PermissionsForMember,
  SimulatableRolesType,
} from '@packages/domains/authorization/permissions/catalog';
import {
  SIMULATE_ROLE_STARTED,
  SIMULATE_ROLE_ENDED,
  DEFAULT_SIMULATED_SITE_ROLE_SET,
  DEFAULT_SIMULATED_SITE_ROLE_CLEARED,
  SITE_MEMBERS_PERMISSIONS_FETCH_REQUESTED,
  SITE_MEMBERS_PERMISSIONS_FETCH_SUCCEEDED,
  SITE_MEMBERS_PERMISSIONS_FETCH_FAILED,
} from '@packages/systems/permissions';

export const fetchSiteMembersPermissionsRequestedAction = createAction<
  typeof SITE_MEMBERS_PERMISSIONS_FETCH_REQUESTED
>(SITE_MEMBERS_PERMISSIONS_FETCH_REQUESTED);

export const fetchSiteMembersPermissionsSucceededAction = createAction<
  typeof SITE_MEMBERS_PERMISSIONS_FETCH_SUCCEEDED,
  {
    response: {
      permissions: PermissionsForMember[];
    };
  }
>(SITE_MEMBERS_PERMISSIONS_FETCH_SUCCEEDED);

export const fetchSiteMembersPermissionsFailedAction = createAction<
  typeof SITE_MEMBERS_PERMISSIONS_FETCH_FAILED
>(SITE_MEMBERS_PERMISSIONS_FETCH_FAILED);

type FetchSiteMembersPermissionsSucceededAction = DesignerActionFromCreator<
  typeof fetchSiteMembersPermissionsSucceededAction
>;

type FetchSiteMembersPermissionsFailedAction = DesignerActionFromCreator<
  typeof fetchSiteMembersPermissionsFailedAction
>;

export type PermissionsAction =
  | FetchSiteMembersPermissionsSucceededAction
  | FetchSiteMembersPermissionsFailedAction;

export const simulateRoleStartedAction: ActionCreator<
  typeof SIMULATE_ROLE_STARTED,
  {
    simulatedSiteRole: SimulatableRolesType;
  }
> = createAction(SIMULATE_ROLE_STARTED);

export const simulateRoleEndedAction =
  createAction<typeof SIMULATE_ROLE_ENDED>(SIMULATE_ROLE_ENDED);

export const defaultSimulatedSiteRoleSetAction: ActionCreator<
  typeof DEFAULT_SIMULATED_SITE_ROLE_SET,
  {
    defaultSimulatedSiteRole: SimulatableRolesType;
  }
> = createAction(DEFAULT_SIMULATED_SITE_ROLE_SET);

export const defaultSimulatedSiteRoleClearedAction = createAction<
  typeof DEFAULT_SIMULATED_SITE_ROLE_CLEARED
>(DEFAULT_SIMULATED_SITE_ROLE_CLEARED);
